module.exports = __webpack_public_path__ + "assets/images/coracao.29c563f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kits/coracao.png
// module id = 819
// module chunks = 1